import { createContext, useContext, useEffect, useState } from "react";
import { authController } from "../api/authController";
import { authService } from "../services/authService";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    const unsubscribe = authService.onAuthChange(async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        const data = await authService.getUserProfile(firebaseUser.uid);
        setProfile(data);
      } else {
        setProfile(null);
      }
    });
    return unsubscribe;
  }, []);
  // ── Écouter Firebase Auth ────────────────────────────────
  useEffect(() => {
    const unsub = authService.onAuthChange(async (firebaseUser) => {
      if (firebaseUser) {
        const role = await authService.getUserRole(firebaseUser.uid);
        setUser(firebaseUser);
        setRole(role);
      } else {
        setUser(null);
        setRole(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  const login = (email, password) =>
    authController.login(email, password);

  const register = (email, password, displayName) =>
    authController.register(email, password, displayName);

  const logout = async () => {
    await authController.logout();
    setUser(null);
    setRole(null);
  };

  const resetPassword = (email) =>
    authController.resetPassword(email);

  return (
    <AuthContext.Provider value={{
      user, role, loading,profile,
      login, register, logout, resetPassword,
      isAdmin: role === "admin",
      isClient: role === "client",
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);